<script>


import LoadingScreen from '@/components/General/LoadingScreen'


export default {
	name: 'Dashboard',
	components: {
		LoadingScreen
	},
	props: {'auth':Object,'secData':Object, 'params':Object},
	data() {
		return {
			isLoading:true,
		}
	},
	
	mounted:function(){
		
		this.isLoading=false
		
	},
	
	methods: {
		
	},	
	
			
	watch: {
		
	},

	computed:{
		
	},
	
}

</script>

<template>
	
	<LoadingScreen :isLoading="isLoading"></LoadingScreen>
	
		
</template>


